import type { Coordinate } from "ol/coordinate";
import type View from "ol/View";

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * 지도 중심을 옮긴다 — 이동 시간이 있고 움직임 줄이기가 아니면 부드럽게, 아니면 즉시.
 * `center` 는 이미 지도 투영으로 바꾼 좌표다.
 */
export const moveViewCenter = (
  view: Pick<View, "animate" | "setCenter">,
  center: Coordinate,
  animationMs: number | undefined,
  reducedMotion: boolean
) => {
  if (animationMs && !reducedMotion) {
    view.animate({ center, duration: animationMs });
    return;
  }
  view.setCenter(center);
};
